module.exports = __webpack_public_path__ + "static/media/list_check.3e90926d.svg";